import { render, staticRenderFns } from "./m-timeline-card.vue?vue&type=template&id=42c945df&scoped=true&"
import script from "./m-timeline-card.vue?vue&type=script&lang=js&"
export * from "./m-timeline-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c945df",
  null
  
)

export default component.exports